// Dummy data untuk website Samsi Madu

export const PRODUCTS = [
  {
    id: "madu-hutan",
    name: "Madu Hutan Liar",
    price: "Rp 95.000",
    unit: "250 ml",
    desc: "Dipanen dari sarang lebah liar Apis dorsata di pedalaman hutan. Rasa kaya dengan aroma bunga hutan yang khas.",
    image:
      "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Terlaris",
  },
  {
    id: "madu-randu",
    name: "Madu Randu Murni",
    price: "Rp 75.000",
    unit: "250 ml",
    desc: "Nektar bunga randu (kapuk) menghasilkan madu berwarna terang dengan rasa manis lembut, cocok untuk keluarga.",
    image:
      "https://images.unsplash.com/photo-1773957949154-a7d1ef35ae76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwaG9uZXklMjBqYXIlMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc4NTIxMjA4MHww&ixlib=rb-4.1.0&q=85",
    tag: "Favorit Keluarga",
  },
  {
    id: "madu-kelengkeng",
    name: "Madu Kelengkeng",
    price: "Rp 85.000",
    unit: "250 ml",
    desc: "Madu dari perkebunan kelengkeng dengan aroma buah yang manis dan harum, tekstur kental premium.",
    image:
      "https://images.pexels.com/photos/4921856/pexels-photo-4921856.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Aroma Buah",
  },
];

export const BENEFITS = [
  {
    title: "Imunitas Alami",
    desc: "Kandungan antioksidan dan enzim alami membantu menjaga daya tahan tubuh setiap hari.",
    icon: "ShieldCheck",
  },
  {
    title: "Energi Berkelanjutan",
    desc: "Gula alami dari nektar memberi energi tahan lama tanpa lonjakan seperti gula olahan.",
    icon: "Zap",
  },
  {
    title: "Pencernaan Sehat",
    desc: "Prebiotik alami mendukung kesehatan usus dan sistem pencernaan yang lebih nyaman.",
    icon: "Leaf",
  },
  {
    title: "Tanpa Campuran",
    desc: "100% madu murni, tanpa gula tambahan, tanpa pengawet, dan tanpa pemanis buatan.",
    icon: "Droplets",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Dari Peternak, Bukan Pabrik",
    desc: "Setiap tetes madu kami berasal langsung dari peternak lebah lokal Jombang yang kami kenal dan percayai.",
  },
  {
    no: "02",
    title: "Panen dengan Sabar",
    desc: "Kami hanya memanen saat madu benar-benar matang di sarang, menjaga rasa dan nutrisi tetap utuh.",
  },
  {
    no: "03",
    title: "Murni Apa Adanya",
    desc: "Tidak dipanaskan berlebihan, tidak disaring paksa. Madu sampai ke tangan Anda seperti dari alam.",
  },
];

export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1642067958050-bfba120a57e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxiZWVrZWVwaW5nJTIwaG9uZXl8ZW58MHx8fHwxNzg1MjEyMDg5fDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-8 md:row-span-2",
    alt: "Sarang lebah madu",
  },
  {
    url: "https://images.unsplash.com/photo-1586779161268-51d3e65d20fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxiZWVrZWVwaW5nJTIwaG9uZXl8ZW58MHx8fHwxNzg1MjEyMDg5fDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-4 md:row-span-1",
    alt: "Peternak lebah memegang bingkai sarang",
  },
  {
    url: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-4 md:row-span-1",
    alt: "Toples madu premium",
  },
  {
    url: "https://images.unsplash.com/photo-1773957949154-a7d1ef35ae76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwaG9uZXklMjBqYXIlMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc4NTIxMjA4MHww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-5 md:row-span-1",
    alt: "Madu mengalir dari sarang",
  },
  {
    url: "https://images.pexels.com/photos/4921856/pexels-photo-4921856.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-7 md:row-span-1",
    alt: "Potongan sarang madu dalam toples",
  },
];

// PLACEHOLDER — ganti dengan titik lokasi produksi asli saat data dikirim
export const PRODUCTION_LOCATION = {
  name: "Rumah Produksi Samsi Madu",
  address: "Ds. Contoh, Kec. Contoh, Kabupaten Jombang, Jawa Timur",
  mapsUrl: "https://maps.google.com/?q=Jombang,Jawa+Timur",
};

// PLACEHOLDER — data mitra contoh, akan diganti saat data asli tersedia
// x, y dalam persen mengacu pada viewBox peta di PartnersMap (0-100, 0-40)
export const PARTNERS = [
  { city: "Medan", x: 10, y: 12 },
  { city: "Palembang", x: 14, y: 32 },
  { city: "Jakarta", x: 18, y: 32 },
  { city: "Bandung", x: 21, y: 33 },
  { city: "Semarang", x: 25, y: 32 },
  { city: "Yogyakarta", x: 26, y: 34 },
  { city: "Surabaya", x: 32, y: 33 },
  { city: "Denpasar", x: 39, y: 35 },
  { city: "Pontianak", x: 28, y: 14 },
  { city: "Balikpapan", x: 38, y: 18 },
  { city: "Makassar", x: 53, y: 23 },
  { city: "Manado", x: 55, y: 10 },
  { city: "Ambon", x: 61, y: 24 },
  { city: "Jayapura", x: 88, y: 16 },
];

export const TESTIMONIALS = [
  {
    name: "Rina Kusuma",
    city: "Surabaya",
    text: "Madunya beneran murni, kerasa banget bedanya sama yang di supermarket. Anak-anak suka madu randu-nya!",
    rating: 5,
  },
  {
    name: "Bapak Hendra",
    city: "Jombang",
    text: "Langganan madu hutan dari sini sudah setahun. Kualitas konsisten dan pengiriman cepat lewat WhatsApp.",
    rating: 5,
  },
  {
    name: "Dewi Anggraeni",
    city: "Malang",
    text: "Aroma madu kelengkengnya juara. Packaging rapi dan pelayanannya ramah banget. Recommended!",
    rating: 5,
  },
  {
    name: "Ahmad Fauzi",
    city: "Kediri",
    text: "Sejak minum madu Samsi tiap pagi, badan terasa lebih fit. Harga sepadan dengan kualitasnya.",
    rating: 5,
  },
];
